module.exports = __webpack_public_path__ + "img/CARRINHO.1db102fd.svg";